import slugify from '@sindresorhus/slugify';

import { truncateText } from '@/utils/resolvers';
import DefaultCard from '@/components/DefaultCard';

export default function CardGrid({
  entries,
  Component = DefaultCard,
  linkSubpath,
  truncatedText,
}) {
  return (
    <div className="-mx-6 flex flex-wrap">
      {entries.map((entry) => (
        <div className="mb-12 flex w-full px-6 md:w-1/2" key={entry.id}>
          <Component
            {...entry}
            subTitle={
              truncatedText
                ? truncateText({ text: entry.subTitle })
                : entry.subTitle
            }
            linkPath={`/${linkSubpath}/${slugify(entry.slug, { lower: true })}`}
          />
        </div>
      ))}
    </div>
  );
}
